(function () {
  var pillsNav = document.querySelector('.makc-menu-toolbar__pills');
  if (!pillsNav) return;

  var pills = Array.prototype.slice.call(pillsNav.querySelectorAll('.makc-pill-scroll-tab'));
  if (!pills.length) return;

  // While true, the IntersectionObserver's updates are ignored -- set for
  // the duration of a tap-triggered scroll so the observer doesn't fight
  // or flicker against the tapped pill before the scroll settles. Manual
  // scrolling (not triggered by a pill tap) never sets this, so it keeps
  // updating the active pill via the observer exactly as before.
  var suppressObserver = false;
  var suppressToken = 0;
  // 700ms was tuned against Menu's own tighter category layout -- bumped
  // for Order, whose sections (and therefore worst-case scroll
  // distances, e.g. Browse back up to Start Here) can be substantially
  // longer. scrollend remains the primary, preferred signal where
  // supported; this is only the fallback for browsers without it or a
  // same-position tap that causes no scroll at all.
  var SCROLL_SETTLE_FALLBACK_MS = 1200;
  var supportsScrollEnd = 'onscrollend' in window;

  function setActivePill(pill) {
    pills.forEach(function (p) {
      p.setAttribute('aria-current', p === pill ? 'true' : 'false');
    });
  }

  // scrollend is the reliable signal that a tap-triggered smooth scroll has
  // actually settled, but a fallback timeout is always armed alongside it
  // too -- covers both browsers without scrollend support and the edge
  // case where the target was already in view, so scrollIntoView causes no
  // scroll and scrollend never fires. A token guards against a fast second
  // tap: if a new tap starts before the first one's suppression window
  // ends, the first one's release (whichever fires first) becomes a no-op
  // instead of prematurely handing control back mid-way through the
  // second scroll.
  function suppressObserverUntilScrollSettles() {
    suppressObserver = true;
    suppressToken += 1;
    var currentToken = suppressToken;

    function release() {
      if (currentToken !== suppressToken) return;
      suppressObserver = false;
      window.removeEventListener('scrollend', release);
    }

    if (supportsScrollEnd) {
      window.addEventListener('scrollend', release, { once: true });
    }
    setTimeout(release, SCROLL_SETTLE_FALLBACK_MS);
  }

  // href stays a real in-page anchor (no-JS/graceful-degrade fallback --
  // a plain jump instead of smooth); this intercepts the click to upgrade
  // it to a smooth scroll when the real target exists.
  pills.forEach(function (pill) {
    pill.addEventListener('click', function (event) {
      var targetEl = document.getElementById(pill.getAttribute('href').slice(1));
      if (!targetEl) return;
      event.preventDefault();
      setActivePill(pill);
      suppressObserverUntilScrollSettles();
      targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Stub: the product grid (and its per-category section elements, ids
  // matching each pill's href) doesn't exist yet. This looks for them
  // defensively and simply observes nothing until a later step wires the
  // grid in -- no fake grid content fabricated just to test this. Active
  // state stays whatever was server-rendered (Light Bites, matching
  // Figma's default) until real targets exist to observe.
  var targets = pills
    .map(function (pill) {
      return document.getElementById(pill.getAttribute('href').slice(1));
    })
    .filter(Boolean);

  if (!targets.length || typeof IntersectionObserver !== 'function') return;

  // rootMargin biases the "current section" toward whichever target has
  // just crossed the upper third of the viewport, the standard
  // scrollspy pattern -- an implementation choice, not a value from
  // Figma.
  //
  // Selection strategy: NOT "whichever visible entry has the smallest
  // boundingClientRect.top" (the original approach) -- that heuristic
  // only holds when every observed target is small and similarly sized
  // (true for Menu's per-card anchors, one card ~175px tall). Order's
  // targets are entire sections, from ~250px to 400px+ tall and wildly
  // variable -- for large targets, "smallest top" stops meaning "nearest
  // the top of the screen": a section the user has mostly scrolled PAST
  // can still have a deeply negative (numerically smaller) top than a
  // section that's just entered view, so the old logic could pick the
  // wrong one. Confirmed as a real, reproducible bug on the Order page
  // (scrolled well into Start Here, "Most loved" pill stayed active) --
  // this needed a different strategy, not a tuned number.
  //
  // Fixed by recomputing, on every observer callback, which target's
  // OWN current bounding box actually contains (or is nearest to) a
  // fixed reference line -- geometry-based, not intersection-ratio- or
  // entry-order-based, so it's correct regardless of target size. The
  // IntersectionObserver is still used as the trigger (efficient, no
  // scroll-event listener needed), but selection no longer depends on
  // which entries the observer happened to report changed this
  // callback -- it re-checks every known target's live position instead.
  // threshold has more steps than before (was a single 0) so the
  // callback -- and therefore this recomputation -- fires reliably as a
  // large target's intersection ratio changes gradually while scrolling
  // through it, not only once at the narrow rootMargin band's edge.
  var REFERENCE_LINE_FRACTION = 0.35;

  // A hidden target (the filter sheet hides non-matching cards, and the
  // category anchor id sits on the card itself -- snippets/makc-menu-
  // card.liquid) reports an all-zero rect, which scored as referenceY
  // below: often nearer than a genuinely visible anchor further down, so
  // a hidden anchor could win and mark the wrong pill current. Skipped
  // outright instead: a category with no visible cards is never the
  // active one.
  function isHiddenTarget(target) {
    return target.hidden || target.offsetParent === null;
  }

  function findActiveTarget() {
    var referenceY = window.innerHeight * REFERENCE_LINE_FRACTION;
    var best = null;
    var bestDistance = Infinity;

    targets.forEach(function (target) {
      if (isHiddenTarget(target)) return;
      var rect = target.getBoundingClientRect();
      var distance;
      if (rect.top <= referenceY && rect.bottom >= referenceY) {
        distance = 0;
      } else if (rect.top > referenceY) {
        distance = rect.top - referenceY;
      } else {
        distance = referenceY - rect.bottom;
      }
      if (distance < bestDistance) {
        bestDistance = distance;
        best = target;
      }
    });

    return best;
  }

  // Recomputes the active pill from the targets' live geometry. The
  // observer calls it on scroll; assets/makc-filter-sheet.js calls it
  // through the export below, synchronously, after clearing filters and
  // scrolling to top but BEFORE the category row is unhidden -- so the
  // row's first painted frame already carries the right aria-current
  // instead of a stale one left over from the filtered grid (which the
  // 150ms colour transition then made visible as a crossfade between two
  // pills). getBoundingClientRect() forces layout, so the caller's
  // scroll and card-visibility changes are already reflected here.
  function refreshActivePill() {
    var activeTarget = findActiveTarget();
    if (!activeTarget) return;

    var matchingPill = pills.filter(function (pill) {
      return pill.getAttribute('href') === '#' + activeTarget.id;
    })[0];

    if (matchingPill) setActivePill(matchingPill);
  }

  // Same cross-file shared-state convention as window.makcScrollLock /
  // window.makcFilters / window.makcCart.
  window.makcMenuToolbar = {
    refreshActivePill: refreshActivePill
  };

  var observer = new IntersectionObserver(
    function () {
      if (suppressObserver) return;
      refreshActivePill();
    },
    { rootMargin: '-30% 0px -60% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
  );

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
